/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetCostSummaryQueryResponse, GetCostSummaryPathParams, GetCostSummary400, GetCostSummary401, GetCostSummary403, GetCostSummary404, GetCostSummary409, GetCostSummary500 } from "../../types/platformBillingController/GetCostSummary.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getCostSummary } from "../../client/platformBillingController/getCostSummary.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getCostSummaryQueryKey = (organizationId: GetCostSummaryPathParams["organizationId"] | undefined) => [{ url: '/api/organizations/:organizationId/platform-billing/cost-summary', params: {organizationId:organizationId} }] as const

export type GetCostSummaryQueryKey = ReturnType<typeof getCostSummaryQueryKey>

export function getCostSummaryQueryOptions(organizationId: GetCostSummaryPathParams["organizationId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getCostSummaryQueryKey(organizationId)
        return queryOptions<GetCostSummaryQueryResponse, ResponseErrorConfig<GetCostSummary400 | GetCostSummary401 | GetCostSummary403 | GetCostSummary404 | GetCostSummary409 | GetCostSummary500>, GetCostSummaryQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getCostSummary(organizationId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get AI cost summary (spend vs budget, currency-projected)
 * {@link /api/organizations/:organizationId/platform-billing/cost-summary}
 */
export function useGetCostSummary<TData = GetCostSummaryQueryResponse, TQueryData = GetCostSummaryQueryResponse, TQueryKey extends QueryKey = GetCostSummaryQueryKey>(organizationId: GetCostSummaryPathParams["organizationId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<GetCostSummaryQueryResponse, ResponseErrorConfig<GetCostSummary400 | GetCostSummary401 | GetCostSummary403 | GetCostSummary404 | GetCostSummary409 | GetCostSummary500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getCostSummaryQueryKey(organizationId)
         

         const query = useQuery({
          ...getCostSummaryQueryOptions(organizationId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetCostSummary400 | GetCostSummary401 | GetCostSummary403 | GetCostSummary404 | GetCostSummary409 | GetCostSummary500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}